window.DEBUG = true;

window.refreshTime = 900000; // Aktualisierung alle x millisekunen (default 20 Minuten = 900000)
// window.refreshTime = 6000; // Aktualisierung alle x millisekunen (default 20 Minuten = 900000)
window.toastTimer = 3;
if (!window.inits) {
    window.inits = [];
}

window.inits = [];

jQuery.fn.extend({
    sortByKey: function() {
        var k = Object.keys(this[0]);
        k.sort();
        var r = {};
        for (var i = 0; i < k.length; i++) {
            r[k[i]] = this[0][k[i]];
        }
        return r;
    }
});

// polyfill URLSearchParams
/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/url-search-params-polyfill@8.0.0/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!(function(t) {
    'use strict';
    var n,
        r = t.URLSearchParams && t.URLSearchParams.prototype.get ? t.URLSearchParams : null,
        e =
        r &&
        'a=1' ===
        new r({
            a: 1
        }).toString(),
        o = r && '+' === new r('s=%2B').get('s'),
        i = '__URLSearchParams__',
        a = !r || ((n = new r()).append('s', ' &'), 's=+%26' === n.toString()),
        c = h.prototype,
        s = !(!t.Symbol || !t.Symbol.iterator);
    if (!(r && e && o && a)) {
        (c.append = function(t, n) {
            v(this[i], t, n);
        }),
        (c.delete = function(t) {
            delete this[i][t];
        }),
        (c.get = function(t) {
            var n = this[i];
            return this.has(t) ? n[t][0] : null;
        }),
        (c.getAll = function(t) {
            var n = this[i];
            return this.has(t) ? n[t].slice(0) : [];
        }),
        (c.has = function(t) {
            return d(this[i], t);
        }),
        (c.set = function(t, n) {
            this[i][t] = ['' + n];
        }),
        (c.toString = function() {
            var t,
                n,
                r,
                e,
                o = this[i],
                a = [];
            for (n in o)
                for (r = l(n), t = 0, e = o[n]; t < e.length; t++) a.push(r + '=' + l(e[t]));
            return a.join('&');
        });
        var u = !!o && r && !e && t.Proxy;
        Object.defineProperty(t, 'URLSearchParams', {
            value: u ?
                new Proxy(r, {
                    construct: function(t, n) {
                        return new t(new h(n[0]).toString());
                    }
                }) :
                h
        });
        var f = t.URLSearchParams.prototype;
        (f.polyfill = !0),
        (f.forEach =
            f.forEach ||
            function(t, n) {
                var r = y(this.toString());
                Object.getOwnPropertyNames(r).forEach(function(e) {
                    r[e].forEach(function(r) {
                        t.call(n, r, e, this);
                    }, this);
                }, this);
            }),
        (f.sort =
            f.sort ||
            function() {
                var t,
                    n,
                    r,
                    e = y(this.toString()),
                    o = [];
                for (t in e) o.push(t);
                for (o.sort(), n = 0; n < o.length; n++) this.delete(o[n]);
                for (n = 0; n < o.length; n++) {
                    var i = o[n],
                        a = e[i];
                    for (r = 0; r < a.length; r++) this.append(i, a[r]);
                }
            }),
        (f.keys =
            f.keys ||
            function() {
                var t = [];
                return (
                    this.forEach(function(n, r) {
                        t.push(r);
                    }),
                    g(t)
                );
            }),
        (f.values =
            f.values ||
            function() {
                var t = [];
                return (
                    this.forEach(function(n) {
                        t.push(n);
                    }),
                    g(t)
                );
            }),
        (f.entries =
            f.entries ||
            function() {
                var t = [];
                return (
                    this.forEach(function(n, r) {
                        t.push([r, n]);
                    }),
                    g(t)
                );
            }),
        s && (f[t.Symbol.iterator] = f[t.Symbol.iterator] || f.entries);
    }

    function h(t) {
        ((t = t || '') instanceof URLSearchParams || t instanceof h) && (t = t.toString()),
        (this[i] = y(t));
    }

    function l(t) {
        var n = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\0'
        };
        return encodeURIComponent(t).replace(/[!'\(\)~]|%20|%00/g, function(t) {
            return n[t];
        });
    }

    function p(t) {
        return t.replace(/[ +]/g, '%20').replace(/(%[a-f0-9]{2})+/gi, function(t) {
            return decodeURIComponent(t);
        });
    }

    function g(n) {
        var r = {
            next: function() {
                var t = n.shift();
                return {
                    done: void 0 === t,
                    value: t
                };
            }
        };
        return (
            s &&
            (r[t.Symbol.iterator] = function() {
                return r;
            }),
            r
        );
    }

    function y(t) {
        var n = {};
        if ('object' == typeof t)
            if (S(t))
                for (var r = 0; r < t.length; r++) {
                    var e = t[r];
                    if (!S(e) || 2 !== e.length)
                        throw new TypeError(
                            "Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements"
                        );
                    v(n, e[0], e[1]);
                }
            else
                for (var o in t) t.hasOwnProperty(o) && v(n, o, t[o]);
        else {
            0 === t.indexOf('?') && (t = t.slice(1));
            for (var i = t.split('&'), a = 0; a < i.length; a++) {
                var c = i[a],
                    s = c.indexOf('='); -
                1 < s ? v(n, p(c.slice(0, s)), p(c.slice(s + 1))) : c && v(n, p(c), '');
            }
        }
        return n;
    }

    function v(t, n, r) {
        var e =
            'string' == typeof r ?
            r :
            null != r && 'function' == typeof r.toString ?
            r.toString() :
            JSON.stringify(r);
        d(t, n) ? t[n].push(e) : (t[n] = [e]);
    }

    function S(t) {
        return !!t && '[object Array]' === Object.prototype.toString.call(t);
    }

    function d(t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
    }
})('undefined' != typeof global ? global : 'undefined' != typeof window ? window : this);

if (!Math.trunc) {
    Math.trunc = function(v) {
        return v < 0 ? Math.ceil(v) : Math.floor(v);
    };
}

/**
 * include piwik/matomo
 * @param {string} siteId
 */
window.piwik = (siteId) => {
    if (location.hostname.match(/\.ddev\./)) {
        return;
    }
    var u = "//stats.dreistrom.land/";
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', '2']);
    var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.async = true;
    g.defer = true;
    g.src = u + 'matomo.js';
    s.parentNode.insertBefore(g, s);
};

window.setBarToggles = (el) => {
    /* toggle des folgenden (von bar.tpl) containers */
    el.find('.bar i.toggle').click(function(ev) {
        var controller = $(this);
        var list = controller.closest('.opener').next();
        // list-container
        list.animate({
                height: 'toggle'
            },
            200,
            function() {
                if (controller.hasClass('icon-right-circle')) {
                    controller.removeClass('icon-right-circle');
                    controller.addClass('icon-down-circle');
                } else {
                    controller.removeClass('icon-down-circle');
                    controller.addClass('icon-right-circle');
                }
            }
        );
    });
};

window.isEmail = (email) => {
    return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
        email
    );
};

window.tools = {
    toast: function(title, message) {
        toastr8.info({
            message: message,
            title: title,
            timeOut: toastTimer * 1000,
            iconClass: 'fa fa-info icon-info',
            imgClass: 'toast-logo',
            positionClass: 'toast8-top-right logo'
        });
    }
};

window.setGraphLabelInit = true;

/**
 * Setzt die Legende für den aktuellen Graphen (Diagramm)
 * @param {HTMLElement} tab
 */
window.setGraphLabel = (event, tab) => {
    var $zoomHideSelector;

    if (event === null) {
        $zoomHideSelector = $(tab);
    } else {
        event.preventDefault();
        $zoomHideSelector = $(event.target);
    }

    if ($zoomHideSelector.text() === 'Niederschlag') {
        $('.zoom-y').hide();
    } else {
        $('.zoom-y').show();
    }

    var $legendContainer = $('.dia-status');
    if ($legendContainer.length === 0) return;
    var el;
    if (tab !== undefined) {
        el = document.getElementById('graph-' + $(tab).attr('aria-controls'));
    } else {
        el = document.getElementById('graph-' + $(event.currentTarget).attr('aria-controls'));
    }
    if (el.graph) {
        $legendContainer = $(el).parent().find('.dia-status');
        $legendContainer.html('');

        var g = el.graph;
        var w = 100 / (el.graph.attributes_.labels_.length + 1);

        // ------------------------------------------------------------
        // Bitte optimieren !!!!
        var columns = 0;
        $(el.graph.attributes_.labels_).each(function(i, el) {
            if (g.rolledSeries_) {
                if (g.rolledSeries_[i] !== null) {
                    for (var n = 0; n < g.rawData_.length; n++) {
                        if (g.rawData_[n][i + 1] !== null) {
                            columns++;
                            break;
                        }
                    }
                }
            }
        });
        //var bCol = Math.floor(12 / (el.graph.attributes_.labels_.length + 1));
        //var legendHtml = '<div class="col-xs-12 col-sm-' + bCol + ' highlightedTime pull-left" ></div>';
        var bCol = Math.floor(12 / (columns + 1));
        var legendHtml =
            '<div class="col-xs-12 col-sm-' +
            bCol * 2 +
            ' col-md-' +
            bCol +
            ' highlightedTime pull-left" ></div>';

        $(el.graph.attributes_.labels_).each(function(i, el) {
            var showLegend = false;
            if (g.rolledSeries_) {
                showLegend = true;
                if (g.rolledSeries_[i] !== null) {
                    showLegend = false;
                    for (var n = 0; n < g.rawData_.length; n++) {
                        if (g.rawData_[n][i + 1] !== null) {
                            showLegend = true;
                            break;
                        }
                    }
                }
            }
            if (showLegend) {
                var cssName = el.replace(/\/|³|²|\s|\[|\]/gi, '_');
                legendHtml +=
                    '<div class="col-xs-12 col-sm-' +
                    bCol * 2 +
                    ' col-md-' +
                    bCol +
                    '" style="color:' +
                    g.attributes_.series_[el].options.color +
                    '" class="dia-value pull-left"><i class="icon-right-dir"/> ' +
                    el +
                    ': <span class="' +
                    cssName +
                    '"></span></div>';
            }
        });
        var fillDiv = 12 - bCol * ($(el.graph.attributes_.labels_).length + 1);
        if (fillDiv > 0) {
            legendHtml += '<div class="col-xs-12 col-sm-' + fillDiv + '"></div>';
        }

        $legendContainer.html(legendHtml);
        el.graph.tabClicked = true;
        const last = tab.closest('.nav-tabs').querySelector('li.active');
        if (!window.setGraphLabelInit || last.querySelector('a') !== tab) {
            const tabContent = document.getElementById(
                $(last.querySelector('a')).attr('aria-controls')
            );
            [tabContent, last].forEach((el) => el.classList.remove('active'));
            tab.parentElement.classList.add('active');
            document.getElementById($(tab).attr('aria-controls')).classList.add('active');
        }
        window.setGraphLabelInit = false;
        // Responsive TAB aktivieren. Muss verzögert ausgeführt werden!
        setTimeout(function() {
            el.graph.resize();
        }, 10);
    } else if (DEBUG) {
        console.debug('empty');
    }
};

// Kontrast und Schriftgrößenauswahl in Cookie setzen
// Cookie wird in bodyclass.js ausgelesen
window.setBodyClassCookie = () => {
    var verfallsDatum = new Date(2200, 1, 1).toGMTString();
    var bodyClass = $('body').attr('class');
    document.cookie = 'bodyClass=' + bodyClass + '; expires=' + verfallsDatum + '; path=/';
};

$.urlParam = function(name) {
    var results = new RegExp('[?&]' + name + '=([^]*)').exec(window.location.href);
    if (results == null) {
        return null;
    } else {
        return results[1] || 0;
    }
};

jQuery.iDCookieInfo = function(opts) {
    var $this = this,
        defaults = {
            container: '\
            <div id="{iDCookie}">\
                    <div class="iDTitle">{title}</div>\
                    <div class="iDBody">{body}\
                        <div style="margin-top: .4em">\
                            <label><input type="checkbox" checked="true" disabled="true" /> Technisch erorderlich</label>\
                            <label><input type="checkbox" class="chkOk" name="_p" value="true" /> {agree}</label>\
                            <br />\
                            <button class="btn btn-primary stat btnAll">Alle akzeptieren</button>\
                            <button class="btn btn-secondary stat btnSave">Auswahl akzeptieren</button>\
                            <button class="btnLink btn btn-secondary">{more}</button>\
                        </div>\
                    </div>\
                </div>\
                ',
            bodyTitle: 'Diese Webseite benutzt Cookies',
            bodyText: 'Cookies helfen uns bei der nutzerfreundlichen Bereitstellung der Webseite. Durch die Nutzung unserer Dienste erklären Sie sich mit dem Einsatz von Cookies einverstanden.',
            backgroundColor: '#111111',
            backgroundOpacity: 0.8,
            fontColor: '#cccccc',
            fontSize: '1.2em',
            titleColor: '#cccccc',
            titleWeight: 'bold',
            titleSize: '1.6em',
            txtBtnOk: 'Statistik (Matomo)',
            btnOkBgColor: '#2f7c33',
            txtBtnMore: 'Mehr',
            btnMoreBgColor: '#2f7c33',
            moreLink: '', // Wenn leer dann kein llink
            moreTarget: true, // true: neues Fenster, flase eigenes
            expire: 30,
            style: false, // eigenes css einbinden oder default (false) verwenden
            id: 'iDCookie', // false: eigene ID.
            cookieName: '_p',
            cookieValue: 'true'
        },
        settings = $.extend(defaults, opts);

    var cook = c.getCookie(settings.cookieName); // readCookie(settings.cookieName);

    /** @type {HTMLInputElement} chk */
    var agbCheck = document.querySelector('.chkOk');
    if (agbCheck) {
        registerCokHandler(jQuery(document), settings.id);
        if (cook === 'true') {
            agbCheck.checked = true;
        }
    }
    if (cook) {
        return;
    }
    var styles = {
        container: {
            position: 'fixed',
            paddingBottom: '1em',
            bottom: 0,
            left: 0,
            width: '100%',
            'background-color': settings.backgroundColor,
            opacity: settings.backgroundOpacity,
            zIndex: 999999
        },
        title: {
            color: settings.titleColor,
            fontWeight: settings.titleWeight,
            textAlign: 'center',
            fontSize: settings.titleSize
        },
        body: {
            color: settings.fontColor,
            textAlign: 'center',
            fontSize: settings.fontSize,
            position: 'relative'
        },
        agree: {
            cursor: 'pointer',
            position: 'realtive',
            display: 'inline',
            bottom: '1em',
            marginLeft: '2em',
            border: '1px solid #eee',
            backgroundColor: settings.btnOkBgColor,
            color: settings.fontColor,
            textAlign: 'center',
            padding: '0.2em 0.4em',
            borderRadius: '0.2em'
        },
        more: {
            cursor: 'pointer',
            position: 'realtive',
            display: 'inline',
            bottom: '1em',
            marginLeft: '1em',
            border: '1px solid #eee',
            backgroundColor: settings.btnMoreBgColor,
            color: settings.fontColor,
            textAlign: 'center',
            padding: '0.2em 0.4em',
            borderRadius: '0.2em'
        }
    };
    settings.container = settings.container.replace('{iDCookie}', settings.id);
    settings.container = settings.container.replace('{title}', settings.bodyTitle);
    settings.container = settings.container.replace('{body}', settings.bodyText);
    settings.container = settings.container.replace('{agree}', settings.txtBtnOk);
    settings.container = settings.container.replace('{more}', settings.txtBtnMore);

    var container = $(settings.container);
    if (settings.moreLink === '') {
        container.find('.iDMore').remove();
    }

    if (!settings.style) {
        container.css(styles.container);
        container.find('.iDTitle').css(styles.title);
        container.find('.iDBody').css(styles.body);
        container.find('.iDAgree').css(styles.agree);
        container.find('.btn').css(styles.agree);
        container.find('.iDMore').css(styles.more);
    }

    registerCokHandler(container, settings.id);

    /** btnLink link */
    container.find('.btnLink').on('click', function(event) {
        if (settings.moreTarget) {
            window.open(settings.moreLink, '_blank');
        } else {
            document.location = settings.moreLink;
        }
    });

    container.hide();
    $('body').append(container);
    jQuery('#' + settings.id).slideDown();
};

function init() {
    piwik('24');
    document.querySelectorAll('.mailZone .no-mailzone').forEach(function(div) {
        div.remove();
    });
    $.iDCookieInfo({
        cookieName: '_p',
        moreTarget: false,
        moreLink: '/Disclaimer'
    });

    $(document).tooltip({
        track: true,
        tooltipClass: 'hwp-tooltip',
        content: function() {
            var tt = $(this).attr('title');
            return tt.replace('\\n', '<br />');
        }
    });
    for (var i = 0; i < inits.length; i++) {
        // console.log(inits[i])
        eval(inits[i]);
    }

    /**
     * Edit-Link
     */
    $('#editPage').click(function(event) {
        var w = window.open(this.href, 'hwp-edit');
        w.focus();
        return false;
    });

    /**
     * Diagram beim aktivieren eines Tabs neu zeichnen
     **/
    $('.dia-tabs li a').click(function(event) {
        setGraphLabel(event, this);
    });

    if ($('#sessiontimeout')) {
        var dlgSession = $('#sessiontimeout').dialog({
            title: 'Abgemeldet'
        });
        $(dlgSession)
            .find('.cancel')
            .click(function(event) {
                dlgSession.dialog('close');
            });
    }

    /* HvD-Bar SN-Keyhole */
    $('#sn-keyhole-id').keypress(function(event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            $('#sn-keyhole').click();
        }
    });
    $('#sn-keyhole').click(function(event) {
        var pageId = $(this).parent().find('input').val();
        if (parseInt(pageId) > 0) {
            $.ajax({
                type: 'POST',
                url: '/Handler/HvD/SNKeyhole',
                data: {
                    data: {
                        pageId: pageId
                    }
                }
            }).done(function(data) {
                /* Wenn die ID nicht existiert wird die 404-Seite zurück gegeben */
                location.href = data;
            });
        }
    });

    /* Lightbox */
    $('a[data-role*="lightbox"]').nivoLightbox({
        effect: 'fadeScale'
    });

    /* toggle des folgenden (von bar.tpl) containers */
    // $('.bar i.toggle').click(function(ev) {
    //     var controller = $(this);
    //     var list = controller.closest('.opener').next();
    //     // list-container
    //     list.animate({
    //         height: "toggle"
    //     }, 200, function() {
    //         if (controller.hasClass('icon-right-circle')) {
    //             controller.removeClass('icon-right-circle');
    //             controller.addClass('icon-down-circle');
    //         } else {
    //             controller.removeClass('icon-down-circle');
    //             controller.addClass('icon-right-circle');
    //         }
    //     });
    // });

    /* toggle von Listen */
    $('.list-row i.toggle').click(function(event) {
        var controller = $(this);
        var list = $(controller.closest('.list-row')).find('.list-body');
        if (list.length === 0) {
            list = $(controller.closest('.list-row')).parent().find('.list-body');
        }
        list.animate({
                height: 'toggle'
            },
            200,
            function() {
                if (controller.hasClass('icon-pencil')) {
                    return;
                }
                if (controller.hasClass('icon-right-circle')) {
                    controller.removeClass('icon-right-circle');
                    controller.addClass('icon-down-circle');
                } else {
                    controller.removeClass('icon-down-circle');
                    controller.addClass('icon-right-circle');
                }
            }
        );
    });

    /* */
    $('.ultoggle').each(function(i, el) {
        $(el).next().toggle();
    });

    $('.ultoggle').click(function(ev) {
        var controller = $(this);
        var icon = controller.find('i');
        var $list = $(controller.next());
        $list.animate({
                height: 'toggle'
            },
            200,
            function() {
                if (icon.hasClass('icon-right-circle')) {
                    icon.removeClass('icon-right-circle');
                    icon.addClass('icon-down-circle');
                } else {
                    icon.removeClass('icon-down-circle');
                    icon.addClass('icon-right-circle');
                }
            }
        );
    });

    /* Neue Seite anlegen */
    $('#btn-create').click(function(ev) {
        ev.preventDefault();
        var items = $('#page-new').find('input,select');
        $.ajax({
                type: 'POST',
                url: '/ajax/page-new.php',
                data: items
            })
            .done(function(data, state, jqxhr) {
                // TODO?
            })
            .fail(function() {
                console.debug('fail');
            });
    });

    /* Element am oberen rand beim scrollen heften */
    var $el = $('.sticky');
    var elTops = [];
    for (i = 0; i < $el.length; i++) {
        elTops[i] = $($el[i]).offset().top;
        /* width-bug! Nicht Responsive */
        $($el[i]).css('width', '225px');
        if ($el[i].querySelector('.options')) {
            $($el[i]).css('width', '230px');
        }
    }
    window.addEventListener('scroll', function() {
        for (i = 0; i < $el.length; i++) {
            if ((window.pageYOffset || document.documentElement.scrollTop) > elTops[i]) {
                $($el[i]).css({
                    position: 'fixed',
                    top: '0px'
                });
            } else {
                $($el[i]).css({
                    position: 'static',
                    top: 'auto'
                });
            }
        }
    });

    /* HVD-Bar */
    var $hvdBarInner = $('#hvd-inner');
    var $hvdBarContainer = $('#hvd-inner .container-fluid');
    var hvdBarOffset = 17;
    $('#hvd-bar .hvd-left').click(function(event) {
        if ($hvdBarInner.width() > 0) {
            $hvdBarInner.animate({
                width: 0,
                'border-width': '0px'
            });
        } else {
            $hvdBarInner.css('border-width', '1px').animate({
                width: $('.content-inner.gradiant-border').width() + hvdBarOffset + 'px'
            });
        }
    });
    $(window).resize(function(event) {
        if ($hvdBarInner.width() > 0) {
            $hvdBarInner.css({
                width: $('.content-inner.gradiant-border').width() + hvdBarOffset + 'px'
            });
        }
    });

    /* jScrollPane */
    function setScrollPanes() {
        var pane = $('.scroll-pane');
        pane.jScrollPane({
            showArrows: true,
            contentWidth: '0px'
        });
        window.panes = pane.data('jsp');
    }
    if ($('.scroll-pane').length > 0) {
        setScrollPanes();
    }

    $(window).resize(function() {
        setScrollPanes();
    });

    /* /hvd/ - Seite */

    // Warnwertetoleranz
    $('#Warnwertetoleranz').selectmenu().selectmenu('menuWidget').addClass('overflow');
    $('.warnwertetoleranzContainer button').click(function(ev) {
        var percent = $('#Warnwertetoleranz').val();
        if ($(ev.target).hasClass('upButton')) {
            percent++;
        } else {
            percent--;
        }

        $('#Warnwertetoleranz').val(percent);
        $('#Warnwertetoleranz').selectmenu('refresh');
    });
    // $('.opener.toggle-close .bar i.toggle').click();

    // WUPSUPP-263
    /** @type {NodeListOf<HTMLAnchorElement>} */
    var anchors = document.querySelectorAll('a');
    anchors.forEach(function(a) {
        if (
            a.href.match(/^http/) &&
            !a.href.match(/(hochwasserportal|hwpsn)\.wupperverband\.de/) &&
            !a.href.match(/\.ddev\.site/) &&
            !a.href.match(/\-uat\./)
        ) {
            a.target = '_blank';
        }
    });

    // Schriftgrößen und Kontrastauswahl
    $('.menu-kontrast').click(function() {
        $('body').toggleClass('kontrast');
        setBodyClassCookie();
    });
    $('.fsize-1').click(function() {
        $('body').removeClass('fsize2');
        $('body').removeClass('fsize3');
        setBodyClassCookie();
    });
    $('.fsize-2').click(function() {
        $('body').addClass('fsize2');
        $('body').removeClass('fsize3');
        setBodyClassCookie();
    });
    $('.fsize-3').click(function() {
        $('body').removeClass('fsize2');
        $('body').addClass('fsize3');
        setBodyClassCookie();
    });
}

window.setTimeout(init, 200);
